import { redirectToLogin } from '@ynap/redirect-utils'

export default function getUserSummary(locale, shouldRedirectToLogin = true) {
    if (window && window.SF && window.SF.getUserSummary) {
        return window.SF.getUserSummary()
            .then((userSummary) => {
                const { userAuthenticationStatus } = userSummary || {}

                if (
                    !shouldRedirectToLogin ||
                    (userSummary &&
                        (typeof userAuthenticationStatus == 'undefined' ||
                            userAuthenticationStatus.toLowerCase() === 'full'))
                ) {
                    return userSummary
                }

                return redirectToLogin(locale.id)
            })
            .catch((error) => {
                if (error.message == 401 && error.status == 403) {
                    return redirectToLogin(locale.id)
                }

                return null
            })
    }
    return Promise.resolve(null)
}
